import(/* webpackMode: "eager" */ "/home/runner/work/lovingnext/lovingnext/src/app/blog/error.tsx");
